import cx from 'classnames2';
import React from 'react';

import { IBaseProps } from '../utils';

import { Button } from '../Button';

import styles from './ButtonGroup.module.scss';

export interface IButtonGroupProps extends IBaseProps {
  /** Sets the size of the <ButtonGroup/> */
  size?: 'default' | 'small' | 'large';
  /** Sets the style variant of the <ButtonGroup/> */
  variant?: 'neutral' | 'naked';
}

export const ButtonGroup: React.FC<IButtonGroupProps> = (props) => {
  return (
    <div className={`${props.className}`}>
      {React.Children.map(props.children, (childRef) => {
        const child = childRef as any;
        const { className, size, variant, ...childProps } = child.props;
        return (
          <Button
            className={cx(props.variant !== 'naked' && styles.buttonGroupButton, className)}
            variant={props.variant || variant}
            size={props.size || size}
            {...childProps}
          >
            {child.props.children}
          </Button>
        );
      })}
    </div>
  );
};

ButtonGroup.defaultProps = {
  className: ''
};
